// Which environment the app runs in: 'dev' (quasar dev), 'test' (npm run build:test) or 'production' (build:prod), #70.
// debug and demo panels (the yellow buttons) show only here (D74), and so does the theme switcher in the account menu (#81)
export var isDevEnvironment = function isDevEnvironment() {
  return appEnvironment() === 'dev';
}; // Sentry's release: the build's git commit (#320); none on dev

export var appRelease = function appRelease() {
  return process.env.BUILD_COMMIT ? 'friends@' + process.env.BUILD_COMMIT : null;
};
export var appEnvironment = function appEnvironment() {
  if (process.env.DEV) return 'dev';
  return process.env.BUILD_TARGET === 'test' ? 'test' : 'production';
};